module.exports = __webpack_public_path__ + "static/media/v1_maze.830a91a7.gif";